__turbopack_context__.v({
  "container": "styles-module__y7EuLq__container",
  "items": "styles-module__y7EuLq__items",
  "wrapper--noResults": "styles-module__y7EuLq__wrapper--noResults",
});
